export default {
    "en": {
        "All_Main_Body_Title1": "Math practice that<br>kids ask for",
        "All_Main_Body_Title1_Description1": "Interactive math app<br>for Pre-K — 2nd Grade that<br>children worldwide LOVE to <br>play independently.",
        "All_Main_Body_Playbutton1": "Watch Video",
        "All_Main_Body_Title2": "9M+ downloads",
        "All_Main_Body_Title2_Description1": "Ranked #1 in App Store Children/Education<br>categories in over 20 countries",
        "All_Main_Body_Title2_Quote1": "“Enuma has done a superb job of providing accessibility options that allows use for all-type learners. Bravo for being all-inclusive!”",
        "All_Main_Body_Title2_Quote2": "“The developers of Todo Math have taken special care to create a math tool that is safe for kids, and aligned to math educational standards and best practices.”",
        "All_Main_Body_Title2_Quote3": "4.7 / 5.0<br>“If I had to recommend only one app to support an early learner’s math fluency, this would be it.”",
        "All_Main_Body_Title2_Source1": "Teachers With Apps",
        "All_Main_Body_Title2_Source2": "Common Sense Media",
        "All_Main_Body_Title2_Source3": "App Store Reviewer",
        "All_Main_Body_Title3": "Putting the FUN<br>in math fundamentals",
        "All_Main_Body_Title3_Subtitle1": "Comprehensive, foundational math practice developed by experts",
        "All_Main_Body_Title3_Subtitle1_Description1": "Applied best practices in child brain development, math education, and user experience.",
        "All_Main_Body_Title3_Subtitle1_Description2": "Expertise from UC Berkeley and Stanford University.",
        "All_Main_Body_Title3_Subtitle1_Description3": "Covers U.S. Common Core State Standards.",
        "All_Main_Body_Title3_Subtitle1_Button1": "See The Curriculum",
        "All_Main_Body_Title3_Subtitle2": "Interactive, delightful<br>& confidence building",
        "All_Main_Body_Title3_Subtitle2_Description1": "Timely, encouraging feedback and<br>a multi-sensory approach.<br>No more workbooks!",
        "All_Main_Body_Title3_Subtitle2_Description2": "Multiple modes, levels, and settings<br>for individualized learning.",
        "All_Main_Body_Title3_Subtitle2_Description3": "2000+ activities, including counting, addition, subtraction, time-telling, multiplication and more!",
        "All_Main_Body_Title3_Subtitle2_Button1": "See All Features",
        "All_Main_Body_Title4": "#1 Math App<br>\nEndorsed by Experts!",
        "All_Main_Body_Title1_Button1": "Try Todo Math",
        "All_Main_Body_Title1_Button2": "Android Download"
    },
    "ko": {
        "All_Main_Body_Title1": "아이들이 스스로<br>찾아하는 수학 연습",
        "All_Main_Body_Title1_Description1": "전세계 아이들이 수학의 재미에 푹!<br> 유아부터 초등 저학년까지<br>인터랙티브한 수학 연습",
        "All_Main_Body_Playbutton1": "영상 보기",
        "All_Main_Body_Title2": "다운로드 900만 건 돌파",
        "All_Main_Body_Title2_Description1": "세계 20개국 이상<br>앱스토어 어린이/교육 부문 1위",
        "All_Main_Body_Title2_Quote1": "“에누마는 모든 유형의 학습자들이 앱을 사용할 수 있도록 배려한 접근성 기능을 도입하였다. 모두를 포용하는 사려 깊은 앱!”",
        "All_Main_Body_Title2_Quote2": "“정규 수학 교육 과정과 최신의 학습 이론을 따르면서도 아이들에게 안전한 앱을 만들기 위해 토도수학의 개발진이 기울인 노력이 엿보인다.\"",
        "All_Main_Body_Title2_Quote3": "4.7 / 5.0<br>\"기초 수학 교육을 위한 앱을 딱 하나만 꼽으라면<br>단연 추천할만한 앱!\"",
        "All_Main_Body_Title2_Source1": "Teachers With Apps",
        "All_Main_Body_Title2_Source2": "Common Sense Media",
        "All_Main_Body_Title2_Source3": "앱스토어 리뷰",
        "All_Main_Body_Title3": "재미있게 놀면서 쌓는<br>수학의 기본기!",
        "All_Main_Body_Title3_Subtitle1": "제대로 만든<br>기초 수학 종합 훈련",
        "All_Main_Body_Title3_Subtitle1_Description1": "아동 뇌 발달, 수학 교육, 사용자 경험 디자인 등 다양한<br>분야의 우수 방법론을 사용했어요.",
        "All_Main_Body_Title3_Subtitle1_Description2": "미국 캘리포니아 버클리대와 스탠퍼드대 출신 전문가들이<br>참여했어요.",
        "All_Main_Body_Title3_Subtitle1_Description3": "미국 공통핵심기준(Common Core State Standard)<br>교과 과정을 반영했어요.",
        "All_Main_Body_Title3_Subtitle1_Button1": "교육과정 보기",
        "All_Main_Body_Title3_Subtitle2": "인터랙티브한 활동으로<br>즐거움도 쑥! 자신감도 쑥!",
        "All_Main_Body_Title3_Subtitle2_Description1": "시기적절한 보상을 통해 격려하고 다감각적인 경험을<br>제공해요. 지루한 학습지는 이제 안녕!",
        "All_Main_Body_Title3_Subtitle2_Description2": "다양한 모드, 레벨, 설정으로 맞춤형 학습이 가능해요.",
        "All_Main_Body_Title3_Subtitle2_Description3": "수 세기, 더하기, 빼기부터 시계 읽기, 곱하기까지!<br>2000개 이상의 다양한 활동이 준비돼있어요.",
        "All_Main_Body_Title3_Subtitle2_Button1": "특징 자세히 보기",
        "All_Main_Body_Title4": "전문가들이 인정한<br>1등 수학 앱",
        "All_Main_Body_Title1_Button1": "토도수학을 사용해 보세요!",
        "All_Main_Body_Title1_Button2": "Android Download"
    },
    "cn": {
        "All_Main_Body_Title1": "孩子喜欢的<br>基础数学搭建APP",
        "All_Main_Body_Title1_Description1": "涵盖60多项生活所需数学知识概念<br>培养主动思考和解决问题的能力与信心",
        "All_Main_Body_Playbutton1": "观看视频",
        "All_Main_Body_Title2": "900万多次下载",
        "All_Main_Body_Title2_Description1": "苹果App Store 20余国排名第一<br>（儿童和教育双榜）",
        "All_Main_Body_Title2_Quote1": "“Enuma在提供可访问性选项方面做得非常出色，方便让所有类型的学习者使用。为都都数学的全能欢呼！”",
        "All_Main_Body_Title2_Quote2": "“都都数学的开发人员特别创建对使用者来说安全的数学工具，并使数学能力成长与最佳实践保持一致。”",
        "All_Main_Body_Title2_Quote3": "4.7 / 5.0<br>“如果只推荐一款早期数学学习者能流利使用的App，我会推荐都都数学。”",
        "All_Main_Body_Title2_Source1": "Teachers With Apps",
        "All_Main_Body_Title2_Source2": "Common Sense Media",
        "All_Main_Body_Title2_Source3": "App Store评论者",
        "All_Main_Body_Title3": "让学习更有趣的<br>应用工具",
        "All_Main_Body_Title3_Subtitle1": "在游戏中了解概念<br>在快乐中巩固知识",
        "All_Main_Body_Title3_Subtitle1_Description1": "独特的游戏化设计<br>给孩子无压力无挫败感的环境",
        "All_Main_Body_Title3_Subtitle1_Description2": "将生活常见的逻辑思维游戏<br>以更科学和智能的方式展现给孩子",
        "All_Main_Body_Title3_Subtitle1_Description3": "74个主题任务覆盖<br>七大生活常用基本数学概念",
        "All_Main_Body_Title3_Subtitle1_Button1": "查看内容",
        "All_Main_Body_Title3_Subtitle2": "丰富 有趣<br>在不断挑战中成长",
        "All_Main_Body_Title3_Subtitle2_Description1": "通过可爱的反馈<br>及时给孩子鼓励和信心!",
        "All_Main_Body_Title3_Subtitle2_Description2": "多种模式、不同等级难度<br>适合不同基础的孩子",
        "All_Main_Body_Title3_Subtitle2_Description3": "2000+有趣的挑战项目<br>重复挑战也不会无聊",
        "All_Main_Body_Title3_Subtitle2_Button1": "了解如何使用",
        "All_Main_Body_Title4": "苹果APP STORE 20+地区<br>儿童和教育双榜热门APP",
        "All_Main_Body_Title1_Button1": "尝试都都数学",
        "All_Main_Body_Title1_Button2": "Android Download"
    },
    "ja": {
        "All_Main_Body_Title1": "子どもたちが求める算数の学習",
        "All_Main_Body_Title1_Description1": "世界の子どもたちが算数の魅力にどっぷり浸かる！<br>幼児から小学校低学年のためのインタラクティブな算数の学習",
        "All_Main_Body_Playbutton1": "動画を見る",
        "All_Main_Body_Title2": "900万ダウンロード突破",
        "All_Main_Body_Title2_Description1": "世界20か国以上のアプリストアで<br>教育/子ども向け部門1位",
        "All_Main_Body_Title2_Quote1": "「Enumaはどんなタイプの学習者もアプリが使えるように配慮し、接近性機能を提供している。すべてを含んだ考え抜かれた素晴らしいアプリ！」",
        "All_Main_Body_Title2_Quote2": "「算数の教育過程と優良な学習理論を反映し、子どもたちが安全に使用できるアプリを作るために、トドさんすうの開発陣が努力を注いでいるのがうかがえる。」",
        "All_Main_Body_Title2_Quote3": "4.7 / 5.0<br>「算数の基礎教育のためのアプリを1つ選ぶなら、<br>絶対にオススメするアプリ！」",
        "All_Main_Body_Title2_Source1": "Teachers With Apps",
        "All_Main_Body_Title2_Source2": "Common Sense Media",
        "All_Main_Body_Title2_Source3": "アプリストア レビュー",
        "All_Main_Body_Title3": "楽しく遊びながら身につく<br>算数の基本",
        "All_Main_Body_Title3_Subtitle1": "包括的で、<br>堅実、基礎的な<br>算数学習",
        "All_Main_Body_Title3_Subtitle1_Description1": "子どもの脳の発達、数学教育、<br>ユーザーエクスペリエンス デザイン等、<br>多分野においての成功事例を適用しました。",
        "All_Main_Body_Title3_Subtitle1_Description2": "アメリカ、カリフォルニアのバークリー大学とスタンフォード大学出身の<br>専門家が参与しました。",
        "All_Main_Body_Title3_Subtitle1_Description3": "アメリカの共通基礎スタンダード(Common Core State Standard)<br>教科過程を反映しました。",
        "All_Main_Body_Title3_Subtitle1_Button1": "教育過程を見る",
        "All_Main_Body_Title3_Subtitle2": "インタラクティブな活動で<br>楽しみいっぱい！自信がつく！",
        "All_Main_Body_Title3_Subtitle2_Description1": "タイムリーな報酬を通して、励みと多感覚的な経験を提供します。<br>退屈な問題集はもういらない！",
        "All_Main_Body_Title3_Subtitle2_Description2": "多様なモード、レベル、設定でオーダーメイドの学習が可能です。",
        "All_Main_Body_Title3_Subtitle2_Description3": "数え、足し算、引き算から時計を読む練習、掛け算まで！<br>2000種以上の多様な活動が準備されています。",
        "All_Main_Body_Title3_Subtitle2_Button1": "特徴を詳しく見る",
        "All_Main_Body_Title4": "専門家が認めた<br> 1位のさんすうアプリ",
        "All_Main_Body_Title1_Button1": "トドさんすうを使ってみよう！",
        "All_Main_Body_Title1_Button2": "Android Download"
    }
}


// WEBPACK FOOTER //
// ./src/text/home/mobile.js